module.exports = __webpack_public_path__ + "img/系统集成.f49cd1d6.jpg";